import React from "react";
import moment from "moment";


const Cell = (props) => {
    const { original } = props;

    const className = `text-left ${original && original.serviceConfirmation.estimatedDate ? "" : "bg-warning"}`;
    return (
        <div className={className} >
            {original && (
                <React.Fragment>
                    Job: {original.jobNumber}
                    <br />
                    Store: {original.storeNumber}
                    <br />
                    Limit: {original.timeLimit}
                    <br />
                    Dates: {moment(original.earliestDate).format("YYYY-MM-DD")} - {moment(original.latestDate).format("YYYY-MM-DD")}
                </React.Fragment>
            )}
        </div>
    );
};

export default Cell;
